module.exports = "../study/imgs/maps/Nagano/S8/Helth/HeatStress/Nagano_HeatStress_GFDL_RCP45_Mid.png";